import { Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DialogAction } from '@lc/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseDialog } from '../../../../../ui/src/lib/dialogs/base/base.dialog';

export class PromptDialogData {
  constructor(readonly title: string, readonly message: string, readonly primaryAction: DialogAction, readonly secondaryActions?: DialogAction[], readonly compact = false) {}
}

@Component({
  selector: 'lc-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss'],
  imports: [BaseDialog],
})
export class PromptDialogComponent {
  private sanitizer = inject(DomSanitizer);
  readonly data = inject<PromptDialogData>(MAT_DIALOG_DATA);

  public message: SafeHtml;

  private readonly _close = new Subject<DialogAction>();
  public readonly close = this._close.asObservable();

  constructor() {
    const { data } = this;

    this.message = this.sanitizer.bypassSecurityTrustHtml(data.message);
  }

  onActionClicked(action: DialogAction) {
    this._close.next(action);
  }
}
